import Frames from "@frog/source/engine/animating/Frames.js"

export default {
    "static": require("./bladesinger-idle-0.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 100,
            "images": [
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-0.png"),
                require("./bladesinger-idle-1.png"),
                require("./bladesinger-idle-2.png"),
                require("./bladesinger-idle-3.png"),
                require("./bladesinger-idle-4.png"),
                require("./bladesinger-idle-5.png"),
                require("./bladesinger-idle-6.png"),
                require("./bladesinger-idle-7.png"),
            ]
        })
    },
    "ready": {
        "frames": Frames.run({
            "tweentime": 80,
            "images": [
                require("./bladesinger-selected-4.png"),
                require("./bladesinger-selected-4.png"),
                require("./bladesinger-selected-4.png"),
                require("./bladesinger-selected-4.png"),
                require("./bladesinger-selected-5.png"),
                require("./bladesinger-selected-6.png"),
                require("./bladesinger-selected-7.png"),
                require("./bladesinger-selected-0.png"),
                require("./bladesinger-selected-0.png"),
                require("./bladesinger-selected-0.png"),
                require("./bladesinger-selected-0.png"),
                require("./bladesinger-selected-1.png"),
                require("./bladesinger-selected-2.png"),
                require("./bladesinger-selected-3.png"),
            ]
        })
    },
}
